@if (overrides) {
  <div class="scope-3">
    <div class="greetings">
      <app-greeting></app-greeting>
      <app-dashboard-apps></app-dashboard-apps>
    </div>
    <section class="dashboard-section">
      <div class="header">
        <div class="header__main-container">
          <div class="header__section-title">
            <mds-icon [key]="icons.FAST_FORWARD"></mds-icon>
            <h3>Forecast</h3>
          </div>
        </div>
      </div>
      <app-forecast-charts [filters]="filtersForm"></app-forecast-charts>
    </section>
    <section class="dashboard-section hotspots">
      <div class="header">
        <div class="header__main-container">
          <div class="header__section-title">
            <mds-icon [key]="icons.HOTSPOTS"></mds-icon>
            <h3>Hotspots</h3>
          </div>
          <div class="header__time-period" role="button" tabindex="0" aria-label="Select time period">
            <div class="header__time-period-container">
              <mds-icon class="calendar" [key]="icons.CALENDAR"></mds-icon>
              <span class="header__time-period-title">Period</span>
            </div>
            <div class="header__time-period-dropdowns">
              <mds-dropdown-menu
                [minWidth]="'64px'"
                [text]="'Year'"
                [options]="yearDropDownOptions"
              [formControl]="filtersForm.controls.year"></mds-dropdown-menu>
              <mds-dropdown-menu
                [minWidth]="'64px'"
                [options]="periodDropDownOptions"
              [formControl]="filtersForm.controls.period"></mds-dropdown-menu>
            </div>
          </div>
        </div>
        @if (lastUpdateTime) {
          <div class="header__action-status">
            <mds-chip
              [showChipIcon]="true"
              [icon]="icons.CIRCLE"
              [label]="'Updated ' + (lastUpdateTime | ordinalDate)"
              [removable]="false"
            ></mds-chip>
          </div>
        }
      </div>
      <div class="filters-container">
        <ng-container [ngTemplateOutlet]="filters"></ng-container>
        <div class="data-quality-section data-quality-view">
          <ng-container [ngTemplateOutlet]="dataquality"></ng-container>
        </div>
      </div>
      <div class="grid-container">
        @if (isSwitchView) {
          <div class="grid-container__data-grid">
            <mds-grid [overrides]="overrides"
              [minHeight]="'100%'"
              [storageKey]="'scope-3'"
              [themeClass]="'ag-theme-material'"
              (gridReady)="onGridReady($event)"
              [sizeColumnsToFit]="true"
            (rowClicked)="onRowClicked($event)"></mds-grid>
          </div>
        }
        @if (isSwitchView) {
          <div class="grid-container__charts-section grid-section-large">
            <app-hotspot-charts [filters]="filtersForm"></app-hotspot-charts>
          </div>
        }
        @if (!isSwitchView) {
          <div class="grid-container grid-section-smaller">
            <div class="grid-container__charts-section">
              <div class="data-quality-section data-quality-smaller">
                <ng-container [ngTemplateOutlet]="dataquality"></ng-container>
              </div>
              <app-hotspot-charts [filters]="filtersForm"></app-hotspot-charts>
            </div>
          </div>
        }
      </div>
    </section>
  </div>
}
<ng-template #filters>
  <form class="filters" [formGroup]="filtersForm">
    <div class="aggregation-group">
      <label>
        <mds-icon [key]="icons.AGGREGATION"></mds-icon>
        <span>Aggregate by</span>
      </label>
      <mds-radio-group
        [options]="aggregationOptions"
        [size]="'small'"
      formControlName="aggregation" class="aggregation-radio"></mds-radio-group>

      <mds-dropdown-menu
        [minWidth]="'80px'"
        [options]="aggregationOptions"
        [selectedValue]="[aggreagationValue?.value]"
      (selectedValueChange)="aggregationMenu($event)"  [text]="aggreagationValue.text" class="aggregation-menu"></mds-dropdown-menu>
    </div>
    <div class="filter-group">
      <label>
        <mds-icon [key]="icons.FILTER"></mds-icon>
        <span>Filter by</span>
      </label>
      <div class="filter-menus">
        <mds-dropdown-menu
          [text]="'Scope 3 category'"
          [multiple]="true"
          [checkbox]="true"
          (searchValueChange)="categorySearchValue$.next($event)"
        [options]="filteredCategoryOptions$ | async" formControlName="category"></mds-dropdown-menu>
        <mds-dropdown-menu
          [text]="'Data Quality'"
          [multiple]="true"
          [checkbox]="true"
        [options]="dataQualityDropDownOptions" formControlName="dataQuality"></mds-dropdown-menu>
        <mds-dropdown-menu
          [text]="'Spend Class'"
          [showSearch]="true"
          [multiple]="true"
          [checkbox]="true"
          (searchValueChange)="spendClassSearchValue$.next($event)"
          (onMenuOpened)="onSpendClassDropdownOpened()"
        [options]="filteredSpendClassOptions$ | async" formControlName="spendClass"></mds-dropdown-menu>
        <mds-dropdown-menu
          [text]="'Buyer Site'"
          [showSearch]="true"
          [multiple]="true"
          [checkbox]="true"
          (searchValueChange)="buyerSiteSearchValue$.next($event)"
          (onMenuOpened)="onBuyerSiteDropdownOpened()"
        [options]="filteredBuyerSiteOptions$ | async" formControlName="buyerSite"></mds-dropdown-menu>
        <mds-dropdown-menu
          [text]="'Supplier Site'"
          [showSearch]="true"
          [multiple]="true"
          [checkbox]="true"
          (searchValueChange)="supplierSiteSearchValue$.next($event)"
          (onMenuOpened)="onSupplierSiteDropdownOpened()"
        [options]="filteredSupplierSiteOptions$ | async" formControlName="supplierSite"></mds-dropdown-menu>
        <mds-dropdown-menu
          [text]="'Product Group'"
          [showSearch]="true"
          [multiple]="true"
          [checkbox]="true"
          (searchValueChange)="productGroupSearchValue$.next($event)"
          (onMenuOpened)="onProductGroupDropdownOpened()"
        [options]="filteredProductGroupOptions$ | async" formControlName="productGroup"></mds-dropdown-menu>
      </div>
    </div>
    <div class="switch-view-group">
      <label>
        <mds-icon [key]="icons.VIEW" [width]="24" [height]="24"></mds-icon>
        <span>Show</span>
      </label>
      <mds-button-toggle
        [checkedButton]="'Table'"
        [multiple]="false"
        [name]="'App Data'"
        [options]="toggleData"
        class="switch-button"
        (change)="onSwitchView()">
      </mds-button-toggle>
    </div>
  </form>
</ng-template>
<ng-template #dataquality>
  <label>
    <span>Data Quality</span>
    <mds-icon [key]="icons.DATA_QUALITY"></mds-icon>
  </label>
  @if (loading) {
    <mds-loader></mds-loader>
  }
  @if (!loading) {
    <highcharts-chart
      class="data-quality-chart"
      [Highcharts]="Highcharts"
      [options]="dataQualityOptions"
    ></highcharts-chart>
  }
</ng-template>
